import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBookmarkCopy2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path d="M18 12v1H8v5l-6-6 6-6v5h8V2h2z" fill="currentColor" />
  </svg>
);
export default SvgBookmarkCopy2;
